import AgTechGrid from '@agtech/web/components/Grids/AgTechGrid';
import AgTechGridLink from '@agtech/web/components/Grids/Controls/AgTechGridLink';
import { AgTechActionButton } from '@agtech/web/components/Buttons/AgTechButtons';
import React from 'react'
import TaskTemplateDialog from '../../dialogs/TaskTemplateDialog';
import TaskTemplateActionMenu from '../menus/TaskTemplateActionMenu';
import { useAgTechQuery } from '@agtech/core/data/queries/AgTechDataQueries';
import { TaskTemplateDataGetTemplatesQuery } from '@sales/data/taskTemplates/TaskTemplateQueries';

const TaskTemplateGrid = () => {
    const gridQuery = useAgTechQuery({
        query: TaskTemplateDataGetTemplatesQuery,
        projection: (templateIndex) => {
            return {
                items: Object.values(templateIndex)
            }
        }
    });

    return (
        <AgTechGrid
            data={{
                itemQuery: gridQuery
            }}
            header={{
                title: `Task Templates`,
                content: () => <div id='settings-task-template-create'><TaskTemplateDialog.Button /></div>
            }}
            columns={[
                {
                    header: "Name",
                    value: item => (
                        <AgTechGridLink
                            content={item.name}
                            onClick={e => e.dialogs.openDialog({
                                dialog: () => <TaskTemplateDialog templateId={item.id} />
                            })}
                        />
                    ),
                    classes: 'bg-slate-100 emphasized'
                },
                {
                    header: "Description",
                    value: i => i.description,
                    size: 2
                }
            ]}
            isRowEntityTheSame={(prev, curr) => {
                return prev.name === curr.name &&
                    prev.description === curr.description;
            }}
            searchConfig={{
                options: [
                    { field: 'Name', value: i => i.name },
                    { field: 'Description', value: i => i.description }
                ],
                placeholder: 'Search templates...'
            }}
            noRecordsConfig={{
                message: 'No task templates were found in the system',
                action: {
                    prompt: 'To create one, click the button below',
                    button: () => <TaskTemplateDialog.Button classes='button-highlight' />
                }
            }}
            actions={{
                rendering: i => (
                    <AgTechActionButton classes='stretched centered container'>
                        <TaskTemplateActionMenu template={i} />
                    </AgTechActionButton>
                )
            }}
        />
    )
}

export default TaskTemplateGrid
